export default __webpack_public_path__ + "static/media/git-logo.d26d59c8.png";